export const eventProduct = (_config, _data, globalConfig) => {
  return {
    'event:product': `${globalConfig.product}`
  };
};